import { NotificationProvider } from './../notification/notification';
import { PetitionTypes } from './../../models/petition-types';
import { AreaProvider } from './../area/area';
import { tableNames, propertyNames } from './../../app/app.constants';
import { Injectable } from '@angular/core';
import { FirebaseProvider } from '../firebase/firebase';
import { GlobalVars } from '../../app/app.environment';
import { QueryModel } from '../../models/query';
import { Observable } from 'rxjs/Observable';
import { Petition } from '../../models/petition';
import { AbsenceMotives } from '../../models/absence-motives';


@Injectable()
export class PetitionProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
    public areaProvider: AreaProvider,
    public notificationProvider: NotificationProvider
  ) {}

  getUserMailbox(userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'mailbox';
    query.equalTo = true;

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
  }

  getUserHistory(userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'process';
    query.equalTo = 'ended';

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
  }

  getUserTasks(userId?: string): Promise<Observable<any>> {
    return new Promise(resolve => {
      this.areaProvider.getAllAreasOnce().subscribe(areas => {
        var involvedAreas = [];
  
        areas.forEach(area => {
          if(area.headsIds && area.headsIds.indexOf(userId || this.globalVars.user.key) >= 0) involvedAreas.push(area.key);
        })
  
        let query = new QueryModel();
      
        query.orderByChild = 'process';
        query.equalTo = 'flow';
    
        resolve(this.firebaseService.list(this.getBaseRoot() + tableNames.Petitions, query)
        .map(petitions => petitions.filter(petition => involvedAreas.indexOf(petition.state) >= 0)))
      })
    })
  }

  getUserPetitionsState(userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'process';
    query.equalTo = 'flow';

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
  }

  /**
   * Recuperar peticions acceptades de tipus absència o compensació d'hores
   * 
   * @param userId 
   */
  getUserAcceptedCalendar(userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'state';
    query.equalTo = 'Aceptado';

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
      .map(petitions => petitions.filter(petition => petition.typeId == PetitionTypes.absence || petition.typeId == PetitionTypes.hourCompensation))
  }

  /**
   * Recuperar peticions acceptades de qualsevol tipus (només una vegada)
   * 
   * @param period 
   * @param userId 
   */
  getUserAcceptedOnce(userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'state';
    query.equalTo = 'Aceptado';

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
  }

  /**
   * Recuperar peticions acceptades de qualsevol tipus
   * 
   * @param period 
   * @param userId 
   */
  getUserAcceptedByPeriodOnce(period: number, userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'state';
    query.equalTo = 'Aceptado';

    return this.firebaseService.listOnce(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
      .map(petitions => petitions
      .filter(petition => petition.period == period || (petition.date ? petition.date.split('-')[0] == period : petition.beginDate.split('-')[0] == period)))
  }

  getAvailableAnnulments(userId?: string): Observable<any[]> {
    let query = new QueryModel();
    
    query.orderByChild = 'process';
    query.equalTo = 'ended';

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserPetitions + '/' + (userId || this.globalVars.user.key), query)
      .map(petitions => petitions.filter(petition => !petition.annulment && !petition.annulmentSended))
  }

  markRead(petition: Petition) {
    petition.mailbox = false;

    return this.updatePetition(petition);
  }

  aprove(petition: Petition) {
    return new Promise((resolve, reject) => {
      this.areaProvider.getAreaOnce(petition.state).subscribe(area => {
        
        console.log(area)
        console.log(petition)

        // Final de flux
        if (area.end) {
          petition.state = 'Aceptado';
          petition.stateName = 'Aceptado';
          petition.process = 'ended';
          petition.mailbox = true;

          console.log(petition)
          
          switch(petition.typeId) {      
            case PetitionTypes.extraHours: {
              this.extraHoursPetition(petition).then(() => {
                this.updatePetition(petition).then(() => resolve(true)).catch(error => reject(error))
              }).catch(error => reject(error))
              break;
            }
    
            case PetitionTypes.hourCompensation: {
              this.hourCompensationPetition(petition).then(() => {
                this.updatePetition(petition).then(() => resolve(true)).catch(error => reject(error))
              }).catch(error => reject(error))
              break;
            }
  
            case PetitionTypes.absence: {
              if (petition.motiveKey != AbsenceMotives.medical) {
                this.discountDays(petition).then(() => {
                  this.updatePetition(petition).then(() => resolve(true)).catch(error => reject(error))
                }).catch(error => reject(error))
                break;
              }
              else this.updatePetition(petition).then(() => resolve(true)).catch(error => reject(error))
              break;
            }
          }
        }
  
        // Continua el flux
        else {
          petition.state = area.upperAreaId;
          petition.stateName = area.upperAreaName;
          return this.updatePetition(petition).then(() => resolve(true)).catch(error => reject(error))
        }
      })
    })
  }

  reject(petition: Petition) {
    petition.process = 'ended';
    petition.state = 'Rechazado';
    petition.stateName = 'Rechazado';
    petition.mailbox = true;

    return this.updatePetition(petition);
  }

  sendAnnulment(originalPetition: Petition, petition: Petition) {
    return new Promise((resolve, reject) => {
      originalPetition.annulmentSended = true;

      // Actualitzar petició original
      this.updatePetition(originalPetition).then(() => {
        
        // Dades de la nova petició (anul·lació)
        petition.annulment = true;
        petition.annulmentSended = true;
        petition.process = 'flow';
        petition.state = this.globalVars.user.areaId;
        petition.stateName = this.globalVars.user.area;
        petition.mailbox = false;
    
        if(petition.typeId == PetitionTypes.absence)
          petition.workDays = -(petition.workDays);
    
        else if(petition.typeId == PetitionTypes.extraHours)
          petition.totalHours = -(petition.totalHours);
    
        else if(petition.typeId == PetitionTypes.hourCompensation)
          petition.compensationHours = -(petition.compensationHours);
  
        delete petition.key;
  
        this.addPetition(petition).then(() => resolve(true)).catch(error => reject(error))
      }).catch(error => reject(error))
    })

  }

  /**
   * Afegir una petició a la base de dades. Comprova les dades d'entrada.
   * 
   * @param petition Petició
   */
  addPetition(petition): Promise<any> {
    return new Promise((resolve, reject) => {
      if(petition.motiveKey == AbsenceMotives.holidays) {

        if(petition.workDays <= Number(this.globalVars.user.pendingHolidays[petition.period])) {
          if(petition.beginDate.toString().split('-', 1).pop() == petition.endDate.toString().split('-', 1).pop()) {
            this.processPetition(petition).then(msg => resolve(msg)).catch(error => reject(error))
          }
  
          else reject(`No se pueden solicitar vacaciones entre dos periodos diferentes. Pídalo por separado.`)
        }
  
        else reject(`No tiene suficientes días de vacaciones.`);
      }
      else if (petition.motiveKey == AbsenceMotives.APs) {
        if(Number(this.globalVars.user.pendingAPs[petition.period]) >= 0.5 || petition.motiveKey == AbsenceMotives.medical) {
          this.processPetition(petition).then(msg => resolve(msg)).catch(error => reject(error))
        }
  
        else reject(`No tiene suficientes días de asuntos propios.`)
      }

      else {
        this.processPetition(petition).then(msg=> resolve(msg)).catch(error => reject(error))
      }
    })
  }

  /**
   * Processar petició al moment d'afegir-la.
   * 
   * @param petition Petició
   */
  private processPetition(petition: Petition) {
    return new Promise((resolve, reject) => {
      // Buscar cap d'àrea
      this.areaProvider.getAreaOnce(petition.areaId).subscribe(area => {
        var receivers = area.headsIds;

        console.log(receivers);

        // Cas en que el sol·licitant és el propi cap de l'àrea.
        if(receivers.indexOf(this.globalVars.user.key) >= 0) {
          console.log("Propi cap d'àrea");

          // Consultar següent àrea del flux
          petition.state = area.upperAreaId;
          petition.stateName = area.upperAreaName;
                    
          // Cas en que el sol·licitant és el propi cap de l'àrea i és l'àrea "arrel".
          if (area.end) {
            petition.state = 'Aceptado';
            petition.stateName = 'Aceptado';
            petition.process = 'ended';
            petition.mailbox = true;
            
            switch(petition.typeId) {      
              case PetitionTypes.extraHours: {
                this.extraHoursPetition(petition).then(() => {
                  this.sendPetition(petition).then(() => resolve(`Petición enviada.`)).catch(error => reject(error))
                }).catch(error => reject(error))
                break;
              }
      
              case PetitionTypes.hourCompensation: {
                this.hourCompensationPetition(petition).then(() => {
                  this.sendPetition(petition).then(() => resolve(`Petición enviada.`)).catch(error => reject(error))
                }).catch(error => reject(error))
                break;
              }

              case PetitionTypes.absence: {
                if (petition.motiveKey != AbsenceMotives.medical) {
                  this.discountDays(petition).then(() => {
                    this.sendPetition(petition).then(() => resolve(`Petición enviada.`)).catch(error => reject(error))
                  }).catch(error => reject(error))
                  break;
                }
                else this.sendPetition(petition).then(() => resolve(`Petición enviada.`)).catch(error => reject(error))
                break;
              }
            }
          }

          else {
            console.log("Cap d'àrea i no final de flux")
            this.sendPetition(petition).then(() => {
              this.notificationProvider.notifyReceivers(petition, receivers);

              resolve(`Petición enviada.`)
            }).catch(error => reject(error))
          }
        }
        // Cas en que el sol·licitant és un usuari normal
        else this.sendPetition(petition).then(() => {
          this.notificationProvider.notifyReceivers(petition, receivers);

          resolve(`Petición enviada.`)
        }).catch(error => reject(error))
      })
    })
  }

  /**
   * Actualitzar les dades de l'usuari a l'afegir hores extra.
   * 
   * @param petition Petició
   */
  private extraHoursPetition(petition: Petition) {
    console.log('extra hours')

    return new Promise((resolve, reject) => {  
      this.firebaseService.propertyOnce(this.getBaseRoot() + tableNames.User + '/' + petition.userKey + '/' + propertyNames.ExtraHours).subscribe(extraHours => {
        extraHours.value = extraHours.value + petition.totalHours;

        this.firebaseService.set(this.getBaseRoot() + '/' + tableNames.User + '/' + petition.userKey, propertyNames.ExtraHours, extraHours.value)
        .then(() => resolve(true)).catch(error => reject(error))
      })
    })
  }

  /**
   * Actualitzar les dades de l'usuari al compensar hores.
   * 
   * @param petition Petició
   */
  private hourCompensationPetition(petition: Petition) {
    console.log('hour compensation')

    return new Promise((resolve, reject) => {  
      this.firebaseService.propertyOnce(this.getBaseRoot() + tableNames.User + '/' + petition.userKey + '/' + propertyNames.ExtraHours).subscribe(extraHours => {

        console.log(extraHours)

        extraHours.value = extraHours.value - petition.compensationHours;

        console.log(extraHours)

        this.firebaseService.set(this.getBaseRoot() + '/' + tableNames.User + '/' + petition.userKey, propertyNames.ExtraHours, extraHours.value)
        .then(() => resolve(true)).catch(error => reject(error))
      })
    })
  }

  /**
   * Dies a descomptar per una petició de vacances o APs
   * 
   * @param petition Petició
   */
  private discountDays(petition: Petition) {
    console.log('discount days')

    var period = Number(petition.period);

    return new Promise((resolve, reject) => {
      if(petition.motiveKey == AbsenceMotives.holidays) {
        this.firebaseService.objectOnce(this.getBaseRoot() + tableNames.User + '/' + petition.userKey + '/' + tableNames.PendingHolidays).subscribe(holidays => {
          holidays[period] = holidays[period] - petition.workDays;
          delete holidays.key;
  
          this.firebaseService.update(this.getBaseRoot() + '/' + tableNames.User + '/' + petition.userKey, tableNames.PendingHolidays, holidays)
          .then(() => resolve(true)).catch(error => reject(error))
        })
      }
      else if (petition.motiveKey == AbsenceMotives.APs) {
        this.firebaseService.objectOnce(this.getBaseRoot() + tableNames.User + '/' + petition.userKey + '/' + tableNames.APs).subscribe(APs => {
          APs[period] = APs[period] - petition.workDays;
          delete APs.key;

          this.firebaseService.update(this.getBaseRoot() + '/' + tableNames.User + '/' + petition.userKey, tableNames.APs, APs)
          .then(() => resolve(true)).catch(error => reject(error))
        })
      }
    })
  }

  /**
   * Crear una petició per primera vegada
   * 
   * @param petition Petició
   */
  private sendPetition(petition) {
    console.log('send petition')

    var petitionsPath = this.getBaseRoot() + '/' + tableNames.Petitions + '/';
    var userPetitionsPath = this.getBaseRoot() + '/' + tableNames.UserPetitions + '/' + this.globalVars.user.key + '/';
    var paths = [petitionsPath, userPetitionsPath];

    return this.firebaseService.multiplePush(petitionsPath, paths, petition);
  }


  /**
   * Modificar una petició
   * 
   * @param petition Petició
   */
  updatePetition(petition: Petition) {
    console.log('update petition')

    var petitionsPath = this.getBaseRoot() + '/' + tableNames.Petitions + '/';
    var userPetitionsPath = this.getBaseRoot() + '/' + tableNames.UserPetitions + '/' + petition.userKey + '/';
    var paths = [petitionsPath, userPetitionsPath];

    var key = petition.key;
    delete petition.key;
    return this.firebaseService.multipleUpdate(paths, key, petition);
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/petition/petition.ts